import { Box, Grid, GridItem, Img, Button, Text } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';

import { ScoreContext } from '../GamePreview';

import { useParams } from 'react-router-dom';

interface GameIntroType {
  preloadedAssets: any;
  setCurrentScreenId: (id: number) => void;
  setIsGetsPlayAudioConfirmation: (value: boolean) => void;
  setPreLogDatas?: any;
  getPrevLogDatas?: any;
  currentScreenId?: any;
  ModelControl: any;
  setModelControl: any;
  gameInfo: any;
  hasMulitLanguages: boolean;
  setIsOpenCustomModal: (value: boolean) => void;
  setReplayState: any;
  setReplayIsOpen: any;
  setQuestState: any;
  gameLanguages: any;
  profileData: any;
  setProfileData: any;
  isInitialLoadScreenWelcome: boolean;
  setIsInitialLoadScreenWelcome: (value: boolean) => void;
}
const IsErrorInitialState: { language: string | null } = {
  language: null,
};
const GameIntroScreen: React.FC<GameIntroType> = ({
  preloadedAssets,
  setCurrentScreenId,
  setIsGetsPlayAudioConfirmation,
  setPreLogDatas,
  getPrevLogDatas,
  currentScreenId,
  setModelControl,
  gameInfo,
  hasMulitLanguages,
  setIsOpenCustomModal,
  setReplayState,
  setReplayIsOpen,
  setQuestState,
  gameLanguages,
  profileData,
  setProfileData,
  isInitialLoadScreenWelcome,
  setIsInitialLoadScreenWelcome,
}) => {
  const { profile, setProfile } = useContext(ScoreContext);
  const [isLanguageSelected, setIsLanguageSelected] = useState(false);
  const [isError, setIsError] = useState(IsErrorInitialState);
  const [isAnimating, setIsAnimating] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const { id } = useParams();
  const Gameid = id ? id : null;
  const [formState, setFormState] = useState<any>({
    language: Gameid
      ? getPrevLogDatas?.previewProfile?.language
        ? getPrevLogDatas?.previewProfile?.language
        : 1
      : profileData?.language
      ? profileData?.language
      : 1, //1 for english
  });

  useEffect(() => {
    if (Gameid) {
      setFormState({
        language: getPrevLogDatas?.previewProfile?.language
          ? getPrevLogDatas?.previewProfile?.language
          : 1,
      });
    }
  }, [getPrevLogDatas]);

  const Handlemodel = () => {
    const newErrors = {
      language:
        gameLanguages.length > 0 && formState.language === ''
          ? 'Language field is mandatory'
          : null,
    };

    setIsError(newErrors);
    const isErrorPresent = Object.values(newErrors).some(
      (error) => error !== null,
    );
    if (!isErrorPresent) {
      setProfileData((prev: any) => ({
        ...prev,
        language: formState.language,
      }));
      if (Gameid) {
        setPreLogDatas((prev: any) => ({
          ...prev,
          previewProfile: {
            ...prev.previewProfile, // Keep the existing fields in previewProfile
            language: formState.language, // Update the language field
            score: prev.previewProfile.score ? prev.previewProfile.score : [], // Keep the existing score or set to an empty array if undefined
          },
        }));

        setIsOpenCustomModal(false);
        if (isInitialLoadScreenWelcome) {
          setIsInitialLoadScreenWelcome(false);
        }
        setProfile(getPrevLogDatas?.previewScore);
        if (getPrevLogDatas?.playerType === 'creator') {
          const getplayerid = getPrevLogDatas?.playerId;

          if (
            getPrevLogDatas &&
            getPrevLogDatas?.questState &&
            Object.entries(getPrevLogDatas?.questState).length > 0
          ) {
            setQuestState(getPrevLogDatas?.questState);
          }
          if (getPrevLogDatas?.screenIdSeq?.length > 0) {
            const screenlast = getPrevLogDatas.screenIdSeq;
            const getLastScreenId = screenlast[0];
            if (getLastScreenId === 2) {
              setReplayState('Prompt');
              setReplayIsOpen(true);
              return false;
            } else {
              setModelControl(true);
              return false;
            }
          } else {
            setCurrentScreenId(1);
            return false;
          }
        } else {
          if (
            getPrevLogDatas?.questState &&
            Object.entries(getPrevLogDatas?.questState).length > 0
          ) {
            setQuestState(getPrevLogDatas?.questState);
          }
          setCurrentScreenId(1);
          return false;
        }
        // }
      } else {
        setIsOpenCustomModal(false);
        if (isInitialLoadScreenWelcome) {
          setIsInitialLoadScreenWelcome(false);
        }
        setCurrentScreenId(1);
        return false;
      }
    }
  };

  const handleProfile = (e: any, input?: any) => {
    const { id, value } = e.target;
    if (id === 'language') {
      setIsLanguageSelected(false);
    }
    // Restrict the length of 'value' to a maximum of 15 characters if 'id' is 'name'
    const trimmedValue = id === 'name' ? value.slice(0, 15) : value;
    setIsError((prevError) => ({ ...prevError, [id]: null }));
    setFormState((prev: any) => ({
      ...prev,
      [id]: id === 'name' ? trimmedValue : input,
    }));
  };
  return (
    <>
      <Img
        src={preloadedAssets.Login}
        onLoad={() => setLoaded(true)}
        display={'none'}
      />
      {loaded && (
        <Box
          position="relative"
          maxW="100%"
          w={'100vw'}
          height="100vh"
          backgroundImage={preloadedAssets?.introBgImage}
          backgroundSize={'cover'}
          backgroundRepeat={'no-repeat'}
          className="chapter_potrait"
          backgroundColor={'#0d161e'}
        >
          <Grid
            templateColumns="repeat(1, 1fr)"
            gap={4}
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            className="story_note_grid"
          >
            <GridItem colSpan={1}>
              <Box
                display={'flex'}
                justifyContent={'center'}
                position={'relative'}
              >
                <Img src={preloadedAssets.Login} className={'first_play'} />
                <Box className={'play_screen_content'}>
                  <Box>
                    <Box w={'100%'} display={'flex'} justifyContent={'center'}>
                      <Text className={'play_screen_heading'}>Atlantis</Text>
                    </Box>
                  </Box>
                  <Box>
                    <Box
                      w={'100%'}
                      display={'flex'}
                      justifyContent={'center'}
                      marginBottom={'20px'}
                    >
                      {/* <Text className={'play_screen_text'}>
                      Welcome To
                    </Text> */}
                    </Box>
                    <Box
                      w={'100%'}
                      display={'flex'}
                      justifyContent={'center'}
                      //  marginBottom={"20px"}
                      // mb={gameLanguages && gameLanguages.length === 1 ? '20%' : ''}
                    >
                      <Text className={'play_screen_text'}>
                        {/* The Game */}
                        {gameInfo?.gameTitle}
                      </Text>
                    </Box>
                    {gameLanguages && gameLanguages.length > 1 && (
                      <Box position={'relative'} mb={'5%'} mr={'25%'}>
                        <Img
                          w={'100%'}
                          h={'auto'}
                          src={preloadedAssets.redLang}
                          onClick={() =>
                            setIsLanguageSelected(!isLanguageSelected)
                          }
                        />
                        <Box
                          w={'100%'}
                          position={'absolute'}
                          borderRadius={'50px'}
                          display={'flex'}
                          onClick={() =>
                            setIsLanguageSelected(!isLanguageSelected)
                          }
                          top={'38.5%'}
                        >
                          <Box
                            w={'80%'}
                            display={'flex'}
                            justifyContent={'center'}
                          >
                            <Text
                              onClick={() =>
                                setIsLanguageSelected(!isLanguageSelected)
                              }
                              className={'choosen_lang'}
                              color={'#35332e !important'}
                            >
                              {gameLanguages.length > 0
                                ? gameLanguages.find(
                                    (lan: any) =>
                                      lan.value === formState?.language,
                                  )?.label
                                : 'English'}
                            </Text>
                          </Box>
                          <Box w={'18%'}>
                            <Img
                              src={preloadedAssets.Selected}
                              className={'select'}
                              mt={'31%'}
                            />
                          </Box>
                          {isLanguageSelected && (
                            <Box
                              className="dropdown"
                              background={
                                'linear-gradient(0deg, #ecdca2, #a48d63)'
                              }
                              color={'#35332e !important'}
                              borderRadius={'2px'}
                            >
                              {gameLanguages.length > 0
                                ? gameLanguages.map((lang: any, num: any) => (
                                    <Text
                                      className={'choosen_langs'}
                                      ml={'5px'}
                                      key={num}
                                      _hover={{
                                        bgColor: '#ffdfa7',
                                        padding: '0 2%',
                                      }}
                                      id={'language'}
                                      onClick={(e: any) =>
                                        handleProfile(e, lang.value)
                                      }
                                    >
                                      {lang.label}
                                    </Text>
                                  ))
                                : null}
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}
                    <Box
                      w={'100%'}
                      display={'flex'}
                      justifyContent={'center'}
                      // mt={'9%'}
                    >
                      <Button
                        w={'90%'}
                        h={{ base: '6vw', sm: '6vw', lg: '5vh' }}
                        bg={'none'}
                        _hover={{ bg: 'none' }}
                        className="mouse_style"
                        onClick={() => {
                          setIsGetsPlayAudioConfirmation(true);
                          Handlemodel();
                        }}
                      >
                        <Img
                          className="profile-okay-btn"
                          src={preloadedAssets.play}
                          w={'100%'}
                          h={'auto'}
                        />
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </GridItem>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default GameIntroScreen;
